import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/ai-token-usage/`;

class cdoAITokenUsage {
    recent = (limit, callback) => {
        util.getJSON(`${servicesURL}recent?limit=${encodeURIComponent(limit)}`, callback);
    }
}

const cdo = new cdoAITokenUsage();
export default cdo;
